import * as React from "react";
const SvgSlash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.75 2.33333L4.66667 11.6667", stroke: "#D3D3DF", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgSlash;
